export default __webpack_public_path__ + "static/media/turbothree.48a7e470.png";